<template>
    <div class="spinner">
        <img src="@/assets/styles/frontend-library/images/spinner-animated.svg" alt="Loading Data">
    </div>
</template>

<script>

export default {
  name: 'LoadingSpinner',
  components: {

  },
  props: {
    //   active: {
    //     required: true
    //   }
  },
};
</script>

<style lang="scss" scoped>
  .spinner {
    @apply ut-mx-auto ut-my-10 ut-text-center;
  }
</style>
